import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'expo-router';
import { getFeaturePage } from '../api/featurePage';
import {
  FeaturePageRouteLayout,
  type FeaturePageRouteState,
} from '../components/business/FeaturePageRouteLayout';
import type { FeaturePageId, FeaturePageViewModel } from '../types/featurePage';

const FEATURE_ID: FeaturePageId = 'answer-detail';

const isEmptyFeaturePage = (page: FeaturePageViewModel): boolean =>
  page.sections.length === 0 && page.metrics.length === 0;

const getErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : '功能数据加载失败，请稍后重试。';

export default function AnswerDetailPage() {
  const router = useRouter();
  const [state, setState] = useState<FeaturePageRouteState>({ status: 'loading' });

  const loadPage = useCallback(async () => {
    setState({ status: 'loading' });
    try {
      const page = await getFeaturePage(FEATURE_ID);
      setState(isEmptyFeaturePage(page) ? { status: 'empty' } : { status: 'success', data: page });
    } catch (error: unknown) {
      setState({ status: 'error', message: getErrorMessage(error) });
    }
  }, []);

  useEffect(() => {
    void loadPage();
  }, [loadPage]);

  const openAction = (href: string | null) => {
    if (href) {
      router.push(href as Parameters<typeof router.push>[0]);
    }
  };

  return (
    <FeaturePageRouteLayout
      state={state}
      onBack={() => router.back()}
      onRetry={loadPage}
      onPressAction={openAction}
    />
  );
}
